import { Config } from '@crm-in-store/mist-shared-config';
import { get } from './request';

export type Tenant = 'th' | 'ck';
export interface FeatureFlags {
    [key: string]: boolean | string[];
}
export interface APIResponse<T> {
    data: T;
}

export interface CrmisFeatureFlags extends FeatureFlags {
    eReceiptAvailable: boolean | string[];
    signUpAvailable: boolean | string[];
    memberIdAvailable: boolean | string[];
    configuration: boolean | string[];
    membershipAndLoyalty: boolean | string[];
    signupQrcodeIdentification: boolean | string[];
}
export const getCrmisFeatureFlagsAsync = async (tenant?: Tenant): Promise<CrmisFeatureFlags | null> => {
    const t = tenant || Config.get('tenant');
    if (!t) {
        const error = new Error('Tenant is not set');
        console.error(error);
        throw error;
    }

    const path = `v1/${t}/features`;
    const response = await get<APIResponse<CrmisFeatureFlags | null>>({ path });

    return response ? response.data : null;
}

const cacheResponse = (asyncCall: typeof getCrmisFeatureFlagsAsync): (tenant?: Tenant, refresh?: boolean) => Promise<CrmisFeatureFlags | null> => {
    let promise: Promise<CrmisFeatureFlags | null>;

    return (tenant?: Tenant): Promise<CrmisFeatureFlags | null> => {
        if (!promise) promise = asyncCall(tenant);
        return promise;
    };
}

export const getCrmisFeatureFlags = cacheResponse(getCrmisFeatureFlagsAsync);
